export const COUPLE = {
  groom: "Prajwal",
  bride: "Aishwarya",
  hashtag: "#PandA",
  weddingDate: "2026-05-13T11:00:00+05:30", // Dhaare Muhurta
  weddingDateLabel: "13 May 2026",
  muhurta: "11:00 AM",
  reception: "7:30 PM onwards",
  venue: "Bhanavi Convention Hall",
  locationUrl: "https://maps.app.goo.gl/5NbxX1aymraxyiRN7",
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1654160500774-bdb76ac6982f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxyb21hbnRpYyUyMHdlZGRpbmclMjBjb3VwbGUlMjBjaW5lbWF0aWN8ZW58MHx8fHwxNzc3NTMyODQ2fDA&ixlib=rb-4.1.0&q=85";

export const STORY_TIMELINE = [
  {
    title: "How We Met",
    body:
      "Every story has a beginning, and ours started with a simple introduction. What began as a conversation arranged by our families slowly turned into something more meaningful. There were polite exchanges, a few curious questions, and an openness to know each other better. What we didn’t expect was how naturally everything would fall into place, as two strangers began discovering a quiet sense of familiarity.",
    image:"images/gallery/Standard.jpeg",
  },
  {
    title: "Our First Meeting",
    body:"What started as a formal meeting became the start of something special. There were the usual nerves, thoughtful pauses, and careful words—but beneath it all was a genuine effort to understand each other. What was meant to be just a meeting turned into hours of easy conversation. By the end of it, the hesitation had softened, replaced by a comfort that felt reassuring and real.",
    image:
      "images/gallery/disco.jpeg",
  },
  {
    title: "Growing Closer",
    body:"Not love at first sight, but something deeper with time. Through conversations, shared thoughts, and small everyday moments, we began to understand each other beyond the surface. Respect turned into admiration, and comfort slowly grew into something more meaningful. Somewhere along the way, what started as an arrangement became a bond we both chose wholeheartedly.",
    image:
      "images/gallery/kisi kisi 3.jpeg",
  },
  {
    title: "The Yes",
    body:"A decision made with trust, respect, and a shared vision for the future. With the support of our families and growing confidence in each other, we took the step that changed everything. It wasn’t just a question or an answer—it was a promise to walk this journey together, built on understanding, patience, and companionship.",
    image:
      "images/gallery/hoovu idtavne.jpeg",
  },
  {
    title: "#PandA Begins ❤️",
    body:"Two families. Two lives. One beautiful beginning. On 13th May 2026, surrounded by love, blessings, and the people who matter most, we begin our journey together. What started as an arrangement has now become a partnership for life—filled with hope, trust, and a promise of forever.",
    image:
      "images/gallery/profile.jpeg",
  },
];

export const GALLERY = ["/images/gallery/disco.jpeg","/images/gallery/full.jpeg","/images/gallery/Standard.jpeg","/images/gallery/kisi kisi 1.jpeg","/images/gallery/kisi kisi 2.jpeg","/images/gallery/kisi kisi 3.jpeg", "/images/gallery/maka nodi.jpeg", "/images/gallery/Alli nodu kaage.jpeg","images/gallery/hoovu idtavne.jpeg","images/gallery/profile.jpeg"];

export const LOVE_NOTES = [
  "See you at #PandA ❤️",
  "Two hearts, one story 💫",
  "Forever begins 13.05.2026 ✨",
  "A #PandA moment is coming 🌹",
  "Save the date — and the hashtag 💍",
  "Love loud, hashtag louder — #PandA",
];

export const AMBIENT_AUDIO =
  "https://cdn.pixabay.com/audio/2022/01/18/audio_d0a13f69d2.mp3";
